var exports = {
  "SA": "VoiceConnectionStatus.module__voiceConnectionContainer___YUw0QV",
  "jf": "VoiceConnectionStatus.module__statusRow___YUw0QV",
  "Tm": "VoiceConnectionStatus.module__channelAvatarStack___YUw0QV",
  "kR": "VoiceConnectionStatus.module__signalIcon___YUw0QV",
  "rI": "VoiceConnectionStatus.module__statusButton___YUw0QV",
  "QQ": "VoiceConnectionStatus.module__statusConnected___YUw0QV",
  "Rg": "VoiceConnectionStatus.module__statusConnecting___YUw0QV",
  "iA": "VoiceConnectionStatus.module__statusDisconnected___YUw0QV",
  "ne": "VoiceConnectionStatus.module__controls___YUw0QV",
  "uH": "VoiceConnectionStatus.module__controlButton___YUw0QV",
  "wH": "VoiceConnectionStatus.module__selected___YUw0QV",
  "Kk": "VoiceConnectionStatus.module__icon___YUw0QV",
  "Hd": "VoiceConnectionStatus.module__connectionInfo___YUw0QV",
  "J3": "VoiceConnectionStatus.module__channelSourceRow___YUw0QV",
  "Dt": "VoiceConnectionStatus.module__channelSourceLink___YUw0QV",
  "_R": "VoiceConnectionStatus.module__channelSourceText___YUw0QV",
  "wl": "VoiceConnectionStatus.module__channelSourceChannel___YUw0QV",
  "EF": "VoiceConnectionStatus.module__channelSourceSeparator___YUw0QV",
  "_u": "VoiceConnectionStatus.module__channelSourceGuild___YUw0QV",
  "wt": "VoiceConnectionStatus.module__connectionIdRow___YUw0QV",
  "TR": "VoiceConnectionStatus.module__connectionIdValue___YUw0QV",
  "Gh": "VoiceConnectionStatus.module__connectionIdValueText___YUw0QV",
  "Hz": "VoiceConnectionStatus.module__connectionIdIcon___YUw0QV",
  "EU": "VoiceConnectionStatus.module__mediaSection___YUw0QV",
  "LA": "VoiceConnectionStatus.module__mediaButton___YUw0QV",
  "A1": "VoiceConnectionStatus.module__cameraActive___YUw0QV",
  "Cb": "VoiceConnectionStatus.module__screenShareActive___YUw0QV",
  "cU": "VoiceConnectionStatus.module__mediaIcon___YUw0QV",
  "jC": "VoiceConnectionStatus.module__popoutContainer___YUw0QV",
  "oO": "VoiceConnectionStatus.module__popoutBodyScroller___YUw0QV",
  "$V": "VoiceConnectionStatus.module__popoutBodyContent___YUw0QV",
  "hY": "VoiceConnectionStatus.module__popoutHeader___YUw0QV",
  "Gb": "VoiceConnectionStatus.module__popoutTitle___YUw0QV",
  "IZ": "VoiceConnectionStatus.module__popoutCloseButton___YUw0QV",
  "nO": "VoiceConnectionStatus.module__popoutStats___YUw0QV",
  "u$": "VoiceConnectionStatus.module__popoutStatsSection___YUw0QV",
  "yk": "VoiceConnectionStatus.module__popoutStatsSectionTitle___YUw0QV",
  "r6": "VoiceConnectionStatus.module__popoutStatsSectionRows___YUw0QV",
  "m1": "VoiceConnectionStatus.module__detailedStatsAccordion___YUw0QV",
  "G8": "VoiceConnectionStatus.module__detailedStatsButton___YUw0QV",
  "X6": "VoiceConnectionStatus.module__detailedStatsButtonText___YUw0QV",
  "VV": "VoiceConnectionStatus.module__detailedStatsCaret___YUw0QV",
  "hM": "VoiceConnectionStatus.module__detailedStatsContent___YUw0QV",
  "cl": "VoiceConnectionStatus.module__detailedStatsInner___YUw0QV",
  "gm": "VoiceConnectionStatus.module__popoutStatRow___YUw0QV",
  "Ub": "VoiceConnectionStatus.module__popoutStatLabel___YUw0QV",
  "Fz": "VoiceConnectionStatus.module__popoutStatValue___YUw0QV",
  "ep": "VoiceConnectionStatus.module__popoutStatTextValue___YUw0QV",
  "mp": "VoiceConnectionStatus.module__deviceBadge___YUw0QV",
  "Vs": "VoiceConnectionStatus.module__deviceBadgeText___YUw0QV",
  "hn": "VoiceConnectionStatus.module__endpointBadge___YUw0QV",
  "iu": "VoiceConnectionStatus.module__endpointBadgeText___YUw0QV",
  "_v": "VoiceConnectionStatus.module__chartContainer___YUw0QV",
  "nS": "VoiceConnectionStatus.module__chartSvg___YUw0QV",
  "$s": "VoiceConnectionStatus.module__gridLine___YUw0QV",
  "rK": "VoiceConnectionStatus.module__gridLineHorizontal___YUw0QV",
  "eB": "VoiceConnectionStatus.module__gridText___YUw0QV",
  "BC": "VoiceConnectionStatus.module__chartLine___YUw0QV",
  "Pi": "VoiceConnectionStatus.module__chartPoint___YUw0QV",
  "Hh": "VoiceConnectionStatus.module__textGreen___YUw0QV",
  "NV": "VoiceConnectionStatus.module__textBackgroundModifierHover___YUw0QV",
  "Bx": "VoiceConnectionStatus.module__iconSmall___YUw0QV",
  "Kt": "VoiceConnectionStatus.module__deviceIcon___YUw0QV",
  "hz": "VoiceConnectionStatus.module__lockIcon___YUw0QV",
  "Gy": "VoiceConnectionStatus.module__nsModalContent___YUw0QV",
  "uU": "VoiceConnectionStatus.module__nsOptions___YUw0QV",
};

module.exports = exports;
